import React from 'react';

import { GTMTracking } from '@common/ui/general';

import powerIcon from '@alumni_v2/images/svg/powerIcon.svg';

import styles from './AskQnAButton.module.scss';

const AskQnAButton = (params) => {
  const {
    onQnAClick,
    name,
    availableForQnA,
  } = params;

  if (availableForQnA) {
    return (
      <GTMTracking
        component="button"
        gtmEventType="cta"
        gtmEventAction="click"
        gtmEventResult="qna_modal_open"
        gtmEventCategory="alumni_directory"
        onClick={onQnAClick}
        role="button"
        tabIndex={-1}
        className={styles.qNaContaienr}
        gtmEventData={{
          click_type: 'qna_modal_open',
          click_text: name,
          click_section: 'card',
        }}
      >
        <div className={styles.qNaText}>
          Available for Q&A
        </div>
        <img src={powerIcon} alt="power-icon" />
      </GTMTracking>
    );
  }
  return null;
};

export default AskQnAButton;
